module.exports = __webpack_public_path__ + "img/aboutUspic.be30c295.png";